import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  root: {},
  wrapper: {
    background: '#f5f5f5',
    // paddingBlock: 12,
    // boxShadow: theme.palette.custom.boxShadow,
    height: theme.palette.custom.captionHeaderHeight,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      height: theme.palette.custom.mobileCaptionHeaderHeight,
    },
  },
  container: {
    paddingInline: theme.palette.custom.lgPaddingInline,
    width: '100%',
    [theme.breakpoints.up('1700')]: {
      paddingInline: theme.palette.custom.xlPaddingInline,
    },
    [theme.breakpoints.down('md')]: {
      paddingInline: theme.palette.custom.smPaddingInline,
    },
  },
  captionContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    rowGap: 2,
  },
  marqueeWrapper: {
    display: 'flex',
    gap: 12,
    alignItems: 'center',
    // '& .MuiTypography-root': {
    //   fontWeight: 500,
    //   textAlign: 'center',
    // },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: 0,
      width: '100%',
      justifyContent: 'center',
    },
  },
  marqueeContainer: {
    width: 220,
  },
  marqueeText: {
    [theme.breakpoints.down('sm')]: {
      '& .MuiTypography-root': {
        fontSize: 13,
      },
    },
  },
  captionText: {
    cursor: 'pointer',
    '& .MuiSvgIcon-root': {
      fontSize: 22,
      color: '#03a503',
    },
    '& .MuiTypography-root': {
      [theme.breakpoints.down('sm')]: {
        fontSize: 12,
      },
    },
  },
  captionBtnWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    '& .MuiButton-root': {
      [theme.breakpoints.down('sm')]: {
        fontSize: 11,
      },
    },
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'space-between',
      width: '100%',
    },
  },
  tryOnBtn: {
    '& .MuiButton-root': {
      borderRadius: 10,
      display: 'flex',
      gap: 4,
      alignItems: 'center',
    },
  },
  tryOnImg: {
    width: 15,
    height: 15,
  },
  headerRoot: {
    height: theme.palette.custom.headerHeight,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    position: 'sticky',
    zIndex: 999,
    top: -1,
    background: '#fff',
  },
  logoContainer: {
    // position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    left: theme.palette.custom.lgPaddingInline,
    '& .MuiSvgIcon-root': {
      fontSize: 36,
      cursor: 'pointer',
      color: '#980000',
      [theme.breakpoints.down('sm')]: {
        fontSize: 34,
      },
    },
    [theme.breakpoints.up('1700')]: {
      left: theme.palette.custom.xlPaddingInline,
    },
    [theme.breakpoints.down('md')]: {
      left: theme.palette.custom.smPaddingInline,
    },
  },
  mobileMenuIcon: {
    paddingInlineEnd: 16,
    display: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
    },
  },
  logo: {
    width: 88,
    height: 54,
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      height: 32,
      width: 64,
    },
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  navbar: {
    display: 'flex',
    alignItems: 'center',
    gap: 58,
    [theme.breakpoints.down('lg')]: {
      gap: 24,
    },
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  customBtn: {
    '& .MuiButton-root': {
      transition: 'all 0.1s ease-in-out 0s',
      [theme.breakpoints.down('sm')]: {
        fontSize: 12,
      },
      '&:hover': {
        borderRadius: 20,
        transition: 'all 0.1s ease-in-out 0s',
      },
    },
  },
  menuLabel: {
    cursor: 'pointer',
    borderBottom: '2px solid transparent',
    '& .MuiTypography-root': {
      textTransform: 'uppercase',
      fontWeight: 600,
    },
    '&:hover': {
      // borderBottom: '2px solid #a21299',
      color: `${theme.palette.custom.main}`,
    },
  },
  dropdown: {
    position: 'relative',
    '&:hover': {
      '& $dropdownWrapper': {
        display: 'block',
      },
      '& $menuLabel': {
        // borderBottom: '2px solid #a21299',
        color: `${theme.palette.custom.main}`,
      },
    },
  },
  dropdownWrapper: {
    display: 'none',
    position: 'absolute',
    top: 18,
    zIndex: 9999,
    paddingBlockStart: 18,
    '&:hover': {
      display: 'block',
    },
  },
  dropdownContent: {
    backgroundColor: '#fff',
    width: 420,
    paddingBlock: 20,
    paddingInline: 20,
    borderRadius: 8,
    boxShadow: '0 3px 5px rgba(131,39,41,.5)',
    maxHeight: `calc(80vh - ${
      theme.palette.custom.captionHeaderHeight +
      theme.palette.custom.headerHeight
    }px)`,
    overflowY: 'auto',
    display: 'flex',
    flexWrap: 'wrap',
  },
  subMenuContainer: {
    minWidth: 120,
  },
  subMenuLabel: {
    '& .MuiTypography-root': {
      paddingBlock: 6,
      color: '#000',
      // fontWeight: 600,
      cursor: 'pointer',
      display: 'inline-flex',
      paddingInlineEnd: 4,
      '&:hover': {
        color: `${theme.palette.custom.main}`,
        fontWeight: 600,
      },
    },
    '&:hover': {
      '& $dropdownContent': {
        display: 'block',
      },
      '& $menuLabel': {
        // borderBottom: '2px solid #a21299',
        color: `${theme.palette.custom.main}`,
      },
    },
  },
  nestedMenuLabel: {
    '& .MuiTypography-root': {
      cursor: 'pointer',
      paddingBlock: 2,
      display: 'inline-flex',
      '&:hover': {
        color: `${theme.palette.custom.main}`,
      },
    },
  },
  drawer: {
    background: theme.palette.custom.gradient,
    height: `calc(100vh - ${
      theme.palette.custom.captionHeaderHeight +
      theme.palette.custom.headerHeight
    }px)`,
    position: 'absolute',
    top: `${
      theme.palette.custom.captionHeaderHeight +
      theme.palette.custom.headerHeight
    }px`,
    left: 0,
    right: 0,
    zIndex: 999,
    overflowY: 'auto',
    [theme.breakpoints.down('sm')]: {
      height: `calc(100vh - ${
        theme.palette.custom.mobileCaptionHeaderHeight +
        theme.palette.custom.headerHeight
      }px)`,
      top: `${
        theme.palette.custom.mobileCaptionHeaderHeight +
        theme.palette.custom.headerHeight
      }px`,
    },
  },

  // ------------------------------------------------
  mainMenu: {
    '&:hover': {
      '& $menuLabelWrapper': {
        '& .MuiTypography-root': {
          color: '#000',
        },
      },
    },
  },
  menuLabelWrapper: {
    display: 'flex',
    gap: 8,
    '& .MuiTypography-root': {
      textTransform: 'capitalize',
    },
  },
  menuIcon: {
    width: 20,
    height: 20,
  },
  subMenu: {
    '&:hover': {
      '& $subMenuLabelWrapper': {
        '& .MuiTypography-root': {
          color: '#000',
        },
      },
    },
  },
  subMenuLabelWrapper: {
    paddingInlineStart: 12,
    display: 'flex',
    gap: 8,
    alignItems: 'center',
    '& .MuiSvgIcon-root': {
      color: '#000',
      fontSize: 6,
    },
  },
  nestedSubMenu: {
    '&:hover': {
      '& $subNestedMenuLabelWrapper': {
        '& .MuiTypography-root': {
          color: '#000',
        },
      },
    },
  },
  subNestedMenuLabelWrapper: {
    paddingInlineStart: 24,
    display: 'flex',
    gap: 8,
    alignItems: 'center',
    '& .MuiSvgIcon-root': {
      color: '#000',
      fontSize: 6,
    },
  },
  // Main menu text
  menuLabelsActive: {
    '& .MuiTypography-root': {
      color: '#000',
      fontWeight: 500,
      fontSize: 14,
    },
  },
  menuLabelsNormal: {
    '& .MuiTypography-root': {
      fontWeight: 500,
      color: '#000',
      fontSize: 14,
    },
  },
  activeIcon: {
    display: 'flex',
    '& .MuiSvgIcon-root': {
      color: '#000',
      fontSize: 20,
    },
  },
  normalIcon: {
    display: 'flex',
    '& .MuiSvgIcon-root': {
      color: '#000',
      fontSize: 26,
    },
  },
  searchWrapper: {
    width: 320,
    [theme.breakpoints.down('lg')]: {
      width: 300,
    },
    [theme.breakpoints.down('sm')]: {
      width: 240,
    },
    [theme.breakpoints.down('400')]: {
      width: 220,
    },
    [theme.breakpoints.down('350')]: {
      width: 'auto',
    },
  },
  searchIcon: {
    cursor: 'pointer',
    display: 'flex',
  },
}))

export default useStyles
